



























































































import BaseComponent from '@/components/base-component.vue';
import FadeTwin from '@/components/UI/fade-twin.vue';
import { decimalFormat } from '@/helpers/decimalFormat';
import { toNumber } from '@/helpers/toNumber';
import { PrescricaoResumoParmDTO } from '@/interfaces/prescription';
import {
  IPrescriptionResume,
  IPrescriptionResumeMaterial
} from '@/interfaces/prescription-base';
import { UnidadeMedidaProdCalcParm } from '@/interfaces/product';
import * as service from '@/services/prescription';
import { UNIT_ML_ID } from '@/settings/consts/prescription-params';
import { cloneDeep } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: { FadeTwin },
})
export default class PrescriptionGeneralResume extends BaseComponent {
  @Prop({
    default: [],
  })
  public products!: any[];
  @Prop()
  public item!: any;

  @Prop()
  public isTranscriptions: boolean;  

  @Prop()
  public idsProdWaiting: Number[];

  public resumeData: any = {} ;

  totalInsumos: IPrescriptionResumeMaterial[] = [];

  private resumeGenerate$: BehaviorSubject<any> = new BehaviorSubject<any>(
    'initialize',
  );

  @Watch('item')
  public onChangeItem(): void {
    this.totalInsumos = [];
  }

  @Watch('item.divisaoBolsas')
  public onChangeDivision(): void {
    this.recalcResume();
  }


  @Watch('item.volumeDesejado')
  public onChangeVolumeTotal(): void {
    this.recalcResume();
  }

  @Watch('products')
  public onChangeProducts(): void {
    this.recalcResume();
  }

  public beforeMount(): void {
    this.setValues({} as IPrescriptionResume);
    this.recalcResume();
    this.subscribeResumeGenarate();
  }

  public mounted(): void {
     if (this.isTranscriptions) {    
        this.compararTranscricoes();
     }
   }

  public updated(): void {
     if (this.isTranscriptions) {    
       this.compararTranscricoes();
     }
  }

  timeoutResume = null;
  private recalcResume() {
    if (this.timeoutResume) {      
      clearTimeout(this.timeoutResume);
    }
    this.timeoutResume = setTimeout(() => {      
      this.recalcResumeExec();
    }, 300);
  }

  private recalcResumeExec(): void { 
    if (this.idsProdWaiting && this.idsProdWaiting.length) {
      return;
    }
    this.totalInsumos = [];
    if (!!this.item.resumo) {
      this.setValues(this.item.resumo);
      return;
    }

    const getWeight = () => {
      if (!!this.item.paciente && !!this.item.paciente.peso) {
        return this.item.paciente.peso;
      } else if (!!this.item.peso) {
        return this.item.peso;
      }
      return 0;
    };

    if (
      !this.products.length ||
      !getWeight() ||
      !toNumber(this.item.volumeDesejado)
    ) {
      this.setValues({} as IPrescriptionResume);
      return;
    }
    const clonedProducts = cloneDeep(this.products);
    const payload = clonedProducts.map((product) => {
      product.unidades = product.unidades.filter(
        (unit) => unit.id === UNIT_ML_ID,
      );
      product.unidadeMedidasProduto = product.unidades;
      return product;
    });

    this.resumeGenerate$.next({
      products: payload,
      weight: getWeight(),
      infusionTime: this.item.tempoInfusao,
      volume: this.item.volumeDesejado,
      division: this.item.divisaoBolsas,
      prescription: this.item,
    });
  }

  private setValues(data: IPrescriptionResume): void {
    this.resumeData = {
      osmolaridade: decimalFormat(data.osmolaridade),
      caloriasTotais: decimalFormat(data.caloriasTotais),
      caloriasNaoProteicas: decimalFormat(data.caloriasNaoProteicas),
      acetatoTotal: decimalFormat(data.acetatoTotal),
      cloretoTotal: decimalFormat(data.cloretoTotal),
      relacaoCalN: decimalFormat(data.relacaoCalN),
      concentracaoGlicose: decimalFormat(data.concentracaoGlicose),
      concentracaoDeLipidios: decimalFormat(data.concentracaoDeLipidios),
      concentracaoAminoacidos: decimalFormat(data.concentracaoAminoacidos),
      calcioMaisMagnesio: decimalFormat(data.calcioMaisMagnesio),
      calcioXFosfato: decimalFormat(data.calcioXFosfato),
      calcioPorFosforo: data.calcioPorFosforo ? decimalFormat(data.calcioPorFosforo) : null,
      sodioMEqL: data.sodioMEqL ? decimalFormat(data.sodioMEqL) : null,
      velocidadeInfusaoPorBolsa1: data.velocidadeInfusaoPorBolsa1
        ? decimalFormat(data.velocidadeInfusaoPorBolsa1)
        : '0',
      velocidadeInfusaoPorBolsa2: data.velocidadeInfusaoPorBolsa2
        ? decimalFormat(data.velocidadeInfusaoPorBolsa2)
        : '0',
      velocidadeInfusaoPorBolsa2Num: data.velocidadeInfusaoPorBolsa2,
      ofertaCaloricakcal: decimalFormat(data.ofertaCaloricakcal),
      ofertaCaloricakg: decimalFormat(data.ofertaCaloricakg),
      proteinas: decimalFormat(data.proteinas),
      proteinasGrama: data.proteinasGrama != null ? decimalFormat(data.proteinasGrama) : null,
      carboidratos: decimalFormat(data.carboidratos),
      lipidios: decimalFormat(data.lipidios),
      totalInsumos: this.setMaterialsTotal(data.totalInsumos),
    };
    if (data.totalInsumos && data.totalInsumos.length) {
      this.totalInsumos = this.setMaterialsTotal(data.totalInsumos);
    }
  }

  private setMaterialsTotal(
    materials: IPrescriptionResumeMaterial[],
  ): IPrescriptionResumeMaterial[] {
    if (!materials) {
      return [];
    }

    return materials.map((material) => {
      return {
        ...material,
        valor: decimalFormat(material.quantidade),
        valorKgDia: decimalFormat(material.quantidadeKgDia)
      };
    });
  }


  public compararTranscricoes(){
    var elementosGeneralResume =  document.querySelectorAll(`.dim-twin.caracteristica-item`);
    var labels= [];
    elementosGeneralResume.forEach((i) =>
       labels.push(i.getAttribute("data-label"))
    );

    var itensComparacao;
    for (const nome in labels) {
       itensComparacao = document.querySelectorAll(`.caracteristica-item[data-label="${labels[nome]}"]`)
       // linhas de resumo que tem nas duas transcrições.. (dos dois lados, compara as duas)
        if(itensComparacao !== undefined && itensComparacao.length > 1){
          // linhas de resumo que estão dos dois lados e estão diferentes..
          if(itensComparacao[0].querySelector('.caracteristica-item-valor').textContent !=
             itensComparacao[1].querySelector('.caracteristica-item-valor').textContent ){
                document
                .querySelectorAll(`.dim-twin[data-label="${labels[nome]}"]`)
                .forEach((i) => i.classList.add('colorDiff'));
          // linhas de resumo que estão dos dois lados e estão iguais em conteúdo..                
          }else{
              document
                .querySelectorAll(`.dim-twin[data-label="${labels[nome]}"]`)
                .forEach((i) => i.classList.remove('colorDiff'));
          }
       }
       // linhas de resumo que so tem numa das transcrições.. (só tem 1 vez)
       else if (itensComparacao !== undefined && itensComparacao.length === 1){
         
          document
          .querySelectorAll(`.dim-twin[data-label="${labels[nome]}"]`)
          .forEach((i) => i.classList.add('colorDiff'));
       }
    }
  }


  private subscribeResumeGenarate(): void {
    this.resumeGenerate$
      .pipe(
        skipWhile((val: any) => val === 'initialize'),
        debounceTime(1),
      )
      .subscribe((val: any) => {
        this.fetchResumeV2()
      });
  }

  private fetchResumeV2() {
    let payload: PrescricaoResumoParmDTO = new PrescricaoResumoParmDTO();
    let p = this.item; 
    payload.load(this.item);
        
    service.resumeGenerateV2(payload).subscribe(
      (data) => {        
          this.setValues(data);
          this.item.osmolaridade = data.osmolaridade;
          this.item.caloriasNaoProteicas = data.caloriasNaoProteicas;
      },
      (error) => {
        this.loader.stop();
        this.toast.show(error.data.message.replace(/\n/g, '</br>'), 'error', true);
      },
    );
  }

}
